import { render, staticRenderFns } from "./AffiliateQrcodePage.vue?vue&type=template&id=4ac83606&"
import script from "./AffiliateQrcodePage.vue?vue&type=script&lang=js&"
export * from "./AffiliateQrcodePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports